import { createContext, useContext } from 'react';
import { api } from './api';

/** Las pantallas reales usan la API salvo que una muestra provea su almacén local. */
export type ClienteTorneo = Pick<typeof api,
  'torneoPublico' | 'cargarResultado' | 'anularResultado' | 'enJuego' | 'iniciarEnCancha' |
  'armarGrupos' | 'deshacerGrupos' | 'sortearDesempate' | 'armarCuadro' | 'deshacerCuadro'>;
export const ClienteTorneoContext = createContext<ClienteTorneo>(api);
export const useClienteTorneo = () => useContext(ClienteTorneoContext);
